<textarea #textarea>{{ initialValue }}</textarea>

<div>
  <ng-container *ngTemplateOutlet="footerTemplate; context: footerContext"></ng-container>
</div>

<ng-content></ng-content>
